import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=0bfa22d3&scoped=true"
import script from "./RecentActivity.vue?vue&type=script&lang=js"
export * from "./RecentActivity.vue?vue&type=script&lang=js"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=0bfa22d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa22d3",
  null
  
)

export default component.exports